import type { ComputedRef } from 'vue'
import type { AppBadgeColor } from '../../app-badge'
import type { BadgeTutorCategoryProps, BadgeTutorCategoryScope } from '../types/interfaces'

interface BadgeTutorCategoryOptions {
  props: BadgeTutorCategoryProps
}

interface BadgeTutorCategoryReturn {
  visible: ComputedRef<boolean>
  color: ComputedRef<AppBadgeColor>
  text: ComputedRef<string>
}

interface ScopeConfigItem {
  color: AppBadgeColor
  text: string
}

const SCOPE_CONFIG: Record<BadgeTutorCategoryScope, ScopeConfigItem> = {
  demo: { color: 'indigo', text: 'Demo' },
  paid: { color: 'emerald', text: 'Paid' },
  all: { color: 'emerald', text: 'All' },
}

const getScope = (categories: string[] | null | undefined): BadgeTutorCategoryScope | null => {
  if (!categories?.length) return null
  const hasDemo = categories.some(c => c.startsWith('DEMO'))
  const hasPaid = categories.some(c => c.startsWith('PAID'))
  if (hasDemo && hasPaid) return 'all'
  if (hasDemo) return 'demo'
  if (hasPaid) return 'paid'
  return null
}

export const useBadgeTutorCategory = ({ props }: BadgeTutorCategoryOptions): BadgeTutorCategoryReturn => {
  const scope = computed<BadgeTutorCategoryScope | null>(() => getScope(props.categories))
  const visible = computed<boolean>(() => scope.value !== null)
  const color = computed<AppBadgeColor>(() => scope.value ? SCOPE_CONFIG[scope.value].color : 'slate')
  const text = computed<string>(() => scope.value ? SCOPE_CONFIG[scope.value].text : '')

  return {
    visible,
    color,
    text,
  }
}
